/* eslint-disable */

import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/database';
import 'firebase/firestore';

let env = '';

const hostname = window.location.hostname;

const dev = {
    dbUrl: "https://augamdev.firebaseio.com",
    id: "augamdev",
    api: "AIzaSyChpKZJDM8UOZG-kQZLpOb7ruXxPetCXPA",
    bucket: "augamdev.appspot.com",
    measurementId: "G-WXHX28MESC"
};

const prod = {
    dbUrl: "https://augam-vegan.firebaseio.com",
    id: "augam-vegan",
    api: "AIzaSyD6DHRVk62s-D2n2oL5eEwdqYvn_5TZZNM",
    bucket: "augam-vegan.appspot.com",
};

if(hostname === 'augam.lv'){
    env = prod;
} else if(hostname === "localhost" || "devel.augam.lv"){
    // env = dev;
    env = prod;
}

let config = {
    apiKey: env.api,
    databaseURL: env.dbUrl,
    projectId: env.id,
    storageBucket: env.bucket
};

firebase.initializeApp(config);

const db = firebase.firestore();
const storage = firebase.storage();


export default {
    db, storage
};